export const formatEpochTime = (epochMillis: number) => {
  const now = Date.now();
  const date = new Date(epochMillis);
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Calculate differences (absolute value)
  const diffMillis = now - epochMillis;
  const absDiffMillis = Math.abs(diffMillis);

  // Time thresholds in milliseconds
  const MINUTE = 60 * 1000;
  const HOUR = 60 * MINUTE;
  const DAY = 24 * HOUR;
  const MONTH = 30 * DAY; // Approximation

  // Within 1 hour (0-59 minutes)
  if (absDiffMillis < HOUR) {
    const minutes = Math.round(absDiffMillis / MINUTE);
    if (minutes === 0) return diffMillis >= 0 ? "just now" : "right now";
    return diffMillis > 0
      ? `${minutes} minute${minutes !== 1 ? "s" : ""} ago`
      : `in ${minutes} minute${minutes !== 1 ? "s" : ""}`;
  }

  // Within 24 hours (1-23 hours)
  if (absDiffMillis < DAY) {
    const hours = Math.floor(absDiffMillis / HOUR);
    return diffMillis > 0
      ? `${hours} hour${hours !== 1 ? "s" : ""} ago`
      : `in ${hours} hour${hours !== 1 ? "s" : ""}`;
  }

  // Within 30 days (1-29 days)
  if (absDiffMillis < MONTH) {
    const days = Math.floor(absDiffMillis / DAY);
    return diffMillis > 0
      ? `${days} day${days !== 1 ? "s" : ""} ago`
      : `in ${days} day${days !== 1 ? "s" : ""}`;
  }

  // Fallback to formatted date in user's timezone
  return date.toLocaleDateString("en-US", {
    timeZone: userTimezone,
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};
